module.exports = __webpack_public_path__ + "img/about-us.ddb17581.svg";